export default {
    name: "Messages",
    key: "Var_Messages",
    variables: [
        "alertsTextColor",
        "errorColor",
        "warningColor",
        "warningColorHover",
        "successColor",
        "infoColor",
    ]
}